module.exports = __webpack_public_path__ + "static/media/steve-route-66.69faa475.jpg";